module.exports = __webpack_public_path__ + "static/media/conta.86af539c.png";